import { pushToDataLayer } from '@/utils/dataLayer'
import type { IOriginItem } from '@/components/clp/types'

const EVENT_NAME = 'clp_event'

export default function () {
  const pageType = computed(() => window?.location?.pathname?.split('/')?.pop() ?? '')
  const localeStore = useLocaleStore()
  const selectedOrigin = useState<IOriginItem | null>('selectedOrigin')

  function pushCLPWithOriginDataLayer(data: object) {
    if (!isDataValid(data)) {
      return false
    }

    pushToDataLayer({
      event: EVENT_NAME,
      ...data,
      page_type: pageType.value,
      site_language: localeStore.selectedLanguage,
      origin_airport_code: selectedOrigin.value?.code ?? ''
    })
  }

  function pushCLPDataLayer(data: object) {
    if (!isDataValid(data)) {
      return
    }

    pushToDataLayer({
      event: EVENT_NAME,
      ...data,
      page_type: pageType.value,
      site_language: localeStore.selectedLanguage
    })
  }

  function pushBBBClpDataLayer(data: object) {
    if (!isDataValid(data)) {
      return
    }

    pushToDataLayer({
      event: EVENT_NAME,
      ...data,
      page_type: `${pageType.value}_ovl`,
      site_language: localeStore.selectedLanguage
    })
  }

  function pushCLPPriceTabsDataLayer(data: object) {
    if (!isDataValid(data)) {
      return
    }

    pushToDataLayer({
      event: EVENT_NAME,
      ...data,
      page_type: pageType.value,
      site_language: localeStore.selectedLanguage,
      generic_event_name: 'price_filtering_tabs'
    })
  }

  function isDataValid(data: object) {
    if (data === null || typeof data !== 'object' || !Object.values(data).length) {
      if (isDev()) {
        console.error('Pass valid data object to CLP data layer')
      }

      return false
    }

    return true
  }

  return {
    pushCLPWithOriginDataLayer,
    pushCLPDataLayer,
    pushBBBClpDataLayer,
    pushCLPPriceTabsDataLayer
  }
}
